/* Shared dropdown navigation for desktop and mobile. */
(() => {
  const header = document.querySelector('header.numuti-header');
  if (!header) return;
  const toggle = header.querySelector('.mobile-menu-toggle');
  const navigation = header.querySelector('#numuti-mobile-menu');
  if (!toggle || !navigation) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  let open = false;

  function render() {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    navigation.hidden = !open;
  }
  function close(returnFocus = false) {
    open = false;
    render();
    if (returnFocus) toggle.focus();
  }

  toggle.hidden = false;
  header.classList.add('mobile-nav-ready');
  render();
  toggle.addEventListener('click', () => {
    open = !open;
    render();
  });
  toggle.addEventListener('keydown', event => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    open = true;
    render();
    navigation.querySelector('a[href]')?.focus();
  });
  navigation.addEventListener('click', event => {
    if (event.target.closest('a[href]')) close();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && open) {
      event.preventDefault();
      close(true);
    }
  });
  document.addEventListener('click', event => {
    if (open && !header.contains(event.target)) close();
  });
  header.addEventListener('focusout', () => {
    requestAnimationFrame(() => {
      if (open && !header.contains(document.activeElement)) close();
    });
  });
  mobile.addEventListener('change', () => {
    const focusWasInNavigation = navigation.contains(document.activeElement);
    close(focusWasInNavigation);
  });
})();

(() => { const f=document.getElementById('creator-form'); if(!f)return; const opts=[...f.querySelectorAll('input[type=checkbox]')]; function sync(){opts[0].setCustomValidity(opts.some(x=>x.checked)?'':'Choose at least one way you would like to work with us.');} opts.forEach(x=>x.addEventListener('change',sync));sync();})();
/* Advance only while the mobile timeline is visible; allow swiping and pause. */
(() => {
 const track=document.querySelector('.creator-steps');if(!track)return;
 const cards=[...track.children], mobile=matchMedia('(max-width:760px)'), reduced=matchMedia('(prefers-reduced-motion:reduce)');
 track.tabIndex=0;track.setAttribute('aria-label','How it works. Swipe to read the four steps.');
 let paused=reduced.matches,visible=false,timer,index=0,touching=false;
 function stop(){clearTimeout(timer);}
 function schedule(){stop();if(!mobile.matches||paused||!visible||document.hidden||touching)return;timer=setTimeout(()=>{index=(index+1)%cards.length;track.scrollTo({left:cards[index].offsetLeft-track.offsetLeft-(track.clientWidth-cards[index].clientWidth)/2,behavior:'smooth'});schedule();},7500);}
 track.addEventListener('pointerdown',()=>{touching=true;stop();});
 window.addEventListener('pointerup',()=>{if(!touching)return;touching=false;schedule();});
 track.addEventListener('focusin',stop);track.addEventListener('focusout',schedule);
 track.addEventListener('scroll',()=>{index=cards.reduce((best,card,i)=>Math.abs(card.offsetLeft-track.offsetLeft-track.scrollLeft)<Math.abs(cards[best].offsetLeft-track.offsetLeft-track.scrollLeft)?i:best,0);},{passive:true});
 new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.6}).observe(track);
 document.addEventListener('visibilitychange',schedule);mobile.addEventListener('change',()=>{if(!mobile.matches)track.scrollTo({left:0});schedule();});reduced.addEventListener('change',()=>{paused=reduced.matches;schedule();});
})();
